module.exports = __webpack_public_path__ + "static/10-0cf5e60c3943c8fca7f1db4e0a982c5c.png";